import { render, staticRenderFns } from "./tab3-tax.vue?vue&type=template&id=c236d5b0&scoped=true&"
import script from "./tab3-tax.vue?vue&type=script&lang=js&"
export * from "./tab3-tax.vue?vue&type=script&lang=js&"
import style0 from "./tab3-tax.vue?vue&type=style&index=0&id=c236d5b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c236d5b0",
  null
  
)

export default component.exports